// Present the native notification response without replacing fetch, paging or permissions.
(function () {
  'use strict';
  function init() {
    var host = document.querySelector('.lxTop_N');
    if (!host || host.dataset.lpNotificationObserver) { return; }
    host.dataset.lpNotificationObserver = 'true';
    var hr = /^hr/i.test(document.documentElement.lang);
    var w = hr ? {
      title:'Obavijesti', recent:'Nedavne aktivnosti', close:'Zatvori obavijesti',
      mark:'Označi sve kao pročitano', saving:'Označavanje…', saved:'Sve je označeno kao pročitano.',
      error:'Označavanje nije uspjelo. Pokušajte ponovno.', empty:'Nema nedavnih obavijesti.',
      switchTo:'Prijeđi na profil tvrtke', loading:'Učitavanje aktivnosti…', end:'To su sve nedavne aktivnosti.'
    } : {
      title:'Notifications', recent:'Recent activity', close:'Close notifications',
      mark:'Mark all as read', saving:'Marking as read…', saved:'All notifications marked as read.',
      error:'Could not mark as read. Please try again.', empty:'No recent notifications.',
      switchTo:'Switch to company profile', loading:'Loading activity…', end:'You’re up to date with recent activity.'
    };
    function node(tag, cls, text) {
      var el = document.createElement(tag); el.className = cls || '';
      if (text) { el.textContent = text; }
      return el;
    }
    function icon(name) {
      var el = node('span', 'far fawe-' + name); el.setAttribute('aria-hidden', 'true'); return el;
    }
    function decorate() {
      var menu = host.querySelector('.lxTop');
      if (!menu || !window.lx || !lx.topMenu.notify) { return; }
      var body = menu.querySelector(':scope > .content');
      if (!body) { return; }
      if (!menu.dataset.lpNotificationReady) {
        menu.dataset.lpNotificationReady = 'true';
        menu.classList.add('lp-notification-menu');
        menu.setAttribute('role', 'region'); menu.setAttribute('aria-label', w.title);
        var header = node('header', 'lp-notification-header');
        var title = node('div', 'lp-notification-title-row');
        title.appendChild(node('h2', '', w.title));
        var close = node('button', 't-Button lp-notification-close');
        close.type = 'button'; close.setAttribute('aria-label', w.close); close.appendChild(icon('times'));
        var trigger = host.querySelector('.t-Button--navBar');
        function dismiss() { lx.topMenu.removeClickListener(); if (trigger) { trigger.focus(); } }
        close.addEventListener('click', dismiss);
        menu.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dismiss(); }
        });
        title.appendChild(close); header.appendChild(title);
        var toolbar = node('div', 'lp-notification-toolbar');
        toolbar.appendChild(node('span', 'lp-notification-caption', w.recent));
        // Retain the server-provided action's availability and native endpoint.
        var nativeMark = menu.querySelector(':scope > .hdr .t-Button');
        if (nativeMark) {
          var mark = node('button', 't-Button lp-notification-mark', w.mark); mark.type = 'button';
          mark.prepend(icon('check-double')); toolbar.appendChild(mark);
          mark.addEventListener('click', function () {
            if (mark.disabled) { return; }
            mark.disabled = true;
            status.textContent = w.saving;
            apex.server.process('markNotifyRead', {}, {dataType:'text', success:function (data) {
              if (/NOK|ORA-\d+|"error"\s*:/i.test(data || '')) { fail(); return; }
              mark.disabled = false; status.textContent = w.saved;
              host.querySelectorAll('.t-Button-badge').forEach(function (badge) { badge.textContent = '0'; badge.style.display = 'none'; });
            }, error:fail});
            function fail() { mark.disabled = false; status.textContent = w.error; }
          });
        }
        header.appendChild(toolbar);
        var old = menu.querySelector(':scope > .hdr'); if (old) { old.remove(); }
        menu.prepend(header);
        var heading = body.querySelector(':scope > .hdrTitle'); if (heading) { heading.remove(); }
        var status = node('p', 'lp-notification-status'); status.setAttribute('role', 'status');
        menu.appendChild(status);
        var appHeader = document.getElementById('t_Header');
        function geometry() {
          menu.style.setProperty('--lp-notification-top', Math.max(0, appHeader ? appHeader.getBoundingClientRect().bottom : 64) + 'px');
        }
        geometry();
        var size = new ResizeObserver(geometry); if (appHeader) { size.observe(appHeader); }
        var removal = new MutationObserver(function () { if (!menu.isConnected) { size.disconnect(); removal.disconnect(); } });
        removal.observe(host, {childList:true});
      }
      var boxes = Array.prototype.slice.call(body.querySelectorAll(':scope > .box:not(.loadMore)'));
      boxes.forEach(function (box, index) {
        if (box.dataset.lpNotificationRow) { return; }
        box.dataset.lpNotificationRow = 'true'; box.classList.add('lp-notification-row');
        var data = lx.topMenu.notify.rows[index] || {};
        var text = box.querySelector('.txt'); if (!text) { return; }
        // Null JSON properties are omitted by APEX; never display their JS placeholders.
        box.querySelectorAll('.msg, .recipients, .link, .ts, .hdr').forEach(function (part) {
          if (/^(undefined|null)?$/i.test(part.textContent.trim())) { part.remove(); }
        });
        var type = box.querySelector('.subBox > .hdr');
        var date = text.querySelector('.ts');
        var meta = node('div', 'lp-notification-meta');
        if (type) { meta.appendChild(type); } if (date) { meta.appendChild(date); }
        text.prepend(meta);
        var subject = text.querySelector('.link');
        if (subject) {
          text.insertBefore(subject, meta.nextSibling);
          if (!data.switchId && data.link && data.link !== '#') {
            var link = node('a', 'lp-notification-subject', subject.textContent);
            link.setAttribute('href', data.link); subject.replaceChildren(link);
          }
        }
        // Replace mouse-only profile switching with one explicit keyboard action.
        box.querySelectorAll('[onclick]').forEach(function (part) {
          if (data.switchId && /lx\.nav\.switch/.test(part.getAttribute('onclick'))) { part.removeAttribute('onclick'); }
        });
        var oldSwitch = text.querySelector('.t-Button');
        if (data.switchId && oldSwitch) {
          var select = node('button', 't-Button lp-notification-switch'); select.type = 'button';
          select.appendChild(icon('building'));
          var destination = node('span', 'lp-notification-switch-text');
          destination.appendChild(node('span', 'lp-notification-switch-label', w.switchTo));
          if (data.switchName) { destination.appendChild(node('span', 'lp-notification-switch-company', data.switchName)); }
          select.appendChild(destination);
          select.appendChild(icon('arrow-right'));
          select.addEventListener('click', function () { lx.nav.switch(data.switchId); });
          oldSwitch.replaceWith(select);
        }
      });
      var loader = body.querySelector('#loadMoreN');
      if (loader && loader.textContent !== w.loading) { loader.textContent = w.loading; }
      var end = body.querySelector('.lp-notification-end');
      if (!loader && !end) { body.appendChild(node('p', 'lp-notification-end', boxes.length ? w.end : w.empty)); }
    }
    new MutationObserver(decorate).observe(host, {childList:true, subtree:true});
    decorate();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
